import _ from 'lodash';
//reducers
import { useAppSelector } from 'hooks/redux.hooks';
import { getCountries } from 'state/reducers/global.reducers';
import { getNewBeneficiary } from 'state/reducers/beneficiary.reducers';
import { selectTranslations } from 'state/reducers/translation.reducers';
//theme
import { LayoutColumn } from 'theme/layouts';
import { NavigationBack } from 'theme/elements/Headers';
import { PageHeaderCard } from 'theme/elements/Cards';
//components
import { ChipType, CustomStatusChip } from 'theme/elements/Chips';
import { FormButton, GeneralButton } from 'theme/elements/Buttons';
//MUI
import { Typography, Stack, Button, Box, useTheme } from '@mui/material';
import Add from '@mui/icons-material/Add';
//constants
import { Beneficiary, BeneficiaryId, BeneficiaryStatus, beneficiaryType } from 'constants/beneficiary.constants';
import { pagesEnum } from 'constants/ui.constants';
import { useNavigate } from 'react-router-dom';
import BeneficiaryNameWithFlag from '../details/BeneficiaryNameWithFlag';

export default function Header() {
	const theme = useTheme();
	const t = useAppSelector(selectTranslations);
	const beneficiary: Partial<Beneficiary> = useAppSelector(getNewBeneficiary);
	const navigate = useNavigate();
	const countries = _.keyBy(useAppSelector(getCountries), 'id');
	const getCountryCode = () => {
		if (_.get(countries, beneficiary.countryId || '')) {
			return String(_.get(countries, beneficiary.countryId || '').alpha2Code);
		}
		return '';
	};
	const getCompanyName = () => {
		return _.isEqual(beneficiary.type, beneficiaryType.COMPANY)
			? beneficiary.companyName
			: beneficiary.firstName + ' ' + beneficiary.lastName;
	};
	return (
		<PageHeaderCard>
			<Stack spacing={2} direction="row">
				<LayoutColumn width="70%">
					<Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
						<Stack direction="row" spacing={2}>
							<Typography variant="h4">
								<NavigationBack />
							</Typography>
							<BeneficiaryNameWithFlag beneficiary={beneficiary} />
							{
								_.includes(
									[BeneficiaryStatus.Approved, BeneficiaryStatus.ApprovedWithRisk],
									beneficiary.status
								) ? (
									<CustomStatusChip type={ChipType.APPROVED} />
								) : (
									<CustomStatusChip
										type={ChipType.NATURAL}
										label={t('portal.status.' + beneficiary.status)}
									/>
								)
								// <Typography variant='caption' color='red' >{t('portal.status.'+beneficiary.status)}</Typography>
							}
						</Stack>
						{_.includes(
							[BeneficiaryStatus.Approved, BeneficiaryStatus.ApprovedWithRisk],
							beneficiary.status
						) && (
							<FormButton>
								<GeneralButton>
									<Button
										onClick={() => {
											navigate(`/${pagesEnum.PAY}/new/${_.get(beneficiary, BeneficiaryId)}`);
										}}
										variant="contained"
										startIcon={<Add sx={{ svg: { fontSize: '24px' } }} />}
									>
										{t('portal.actions.pay_now')}
									</Button>
								</GeneralButton>
							</FormButton>
						)}
					</Box>
				</LayoutColumn>
			</Stack>
		</PageHeaderCard>
	);
}
